import { CheckInConfigurationType, CheckInConfigurationValue } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import {
    addressSection,
    documentFieldsWithTypes,
    extendedGeneralSection,
    FieldData,
    guestVerificationSection,
} from '../sections';
import { CheckInCheckboxStates, CheckInColumnName, CheckInFieldsValues } from '../types';
import { TabItemValue } from '../CheckInTabs/enums';
import { ConfigurationTooltip, getTooltipLabel } from '../tooltip/mapTooltipText';

interface AreSectionValuesModifiedOptions {
    initialValues: CheckInFieldsValues;
    sectionFieldData: FieldData[];
    columnName: Exclude<CheckInColumnName, 'reservationOwner'>;
}

export const areSectionValuesModified = ({
    initialValues,
    sectionFieldData,
    columnName,
}: AreSectionValuesModifiedOptions): boolean =>
    sectionFieldData.some((field) => {
        const config = initialValues[field.type];
        if (config == null) return false;
        const value = config[columnName];
        return value != null && value !== CheckInConfigurationValue.DoNotShow;
    });

const getSectionCheckboxState = (values: CheckInFieldsValues, section: FieldData[]) => ({
    reservationAdult: areSectionValuesModified({
        initialValues: values,
        sectionFieldData: section,
        columnName: 'reservationAdult',
    }),
    reservationChild: areSectionValuesModified({
        initialValues: values,
        sectionFieldData: section,
        columnName: 'reservationChild',
    }),
});

export const calculateCheckboxesState = (values: CheckInFieldsValues): CheckInCheckboxStates => ({
    [TabItemValue.General]: getSectionCheckboxState(values, extendedGeneralSection),
    [TabItemValue.Address]: getSectionCheckboxState(values, addressSection),
    [TabItemValue.Documents]: getSectionCheckboxState(values, documentFieldsWithTypes),
    [TabItemValue.GuestVerification]: getSectionCheckboxState(values, guestVerificationSection),
});

interface GetTooltipTextProps {
    columnName: CheckInColumnName;
    fieldName: string;
    tooltip: ConfigurationTooltip;
    type: CheckInConfigurationType;
    visibility?: CheckInConfigurationValue;
}

export const getTooltipText = ({ type, columnName, tooltip, fieldName, visibility }: GetTooltipTextProps) => {
    if (type === CheckInConfigurationType.RelationshipToReservationOwner && columnName === 'reservationOwner') {
        return lt('CheckInFieldRelationshipToReservationOwnerTooltip');
    }
    if (visibility === CheckInConfigurationValue.Required && type === CheckInConfigurationType.LastName) {
        return lt('LastNameFieldIsAlwaysRequired', { fieldName });
    }
    return getTooltipLabel({ tooltipValue: tooltip, fieldName });
};
